(function() {
  var TOGGLE_INIT_FLAG = '__cardVariantsToggleInitialized';
  var isDesktop = window.matchMedia('(min-width: 990px)');
  var sheet;
  var backdrop;
  var sheetBody;
  var sheetCloseBtn;
  var activeState = null;

  function onReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
      return;
    }
    cb();
  }

  function ensureSheet() {
    sheet = document.querySelector('.card-variants-sheet');
    backdrop = document.querySelector('.card-variants-sheet-backdrop');

    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'card-variants-sheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.innerHTML = '<div class="card-variants-sheet__header"><strong class="h5" style="margin:0;">Options</strong><button class="card-variants-sheet__close" aria-label="Close">✕</button></div><div class="card-variants-sheet__body"></div>';
      document.body.appendChild(sheet);
    }

    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'card-variants-sheet-backdrop';
      document.body.appendChild(backdrop);
    }

    sheetBody = sheet.querySelector('.card-variants-sheet__body');
    sheetCloseBtn = sheet.querySelector('.card-variants-sheet__close');
  }

  function closeAllInfoContainers() {
    document.querySelectorAll('.card-variants-info-container.is-open').forEach(function(container) {
      container.classList.remove('is-open');
    });
  }

  function toggleInfoContainer(card) {
    if (!card) return;
    var container = card.querySelector('.card-variants-info-container');
    if (!container) return;
    var wasOpen = container.classList.contains('is-open');
    closeAllInfoContainers();
    if (!wasOpen) container.classList.add('is-open');
  }

  function closeInfoContainer(card) {
    if (!card) return;
    var container = card.querySelector('.card-variants-info-container');
    if (container) container.classList.remove('is-open');
  }

  function openSheet(card, toggleBtn) {
    if (!card || !toggleBtn || isDesktop.matches) return;
    var variants = card.querySelector('.card__variants');
    if (!variants) return;
    ensureSheet();

    if (activeState && activeState.card !== card) closeSheet();

    var placeholder = card.querySelector('.card__variants-placeholder');
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'card__variants-placeholder';
      if (variants.parentNode) variants.parentNode.insertBefore(placeholder, variants.nextSibling);
    }

    var variantScript = card.querySelector('script[id^="Variants-"]');
    var scriptPlaceholder = card.querySelector('.card__variants-script-placeholder');
    if (variantScript && !scriptPlaceholder) {
      scriptPlaceholder = document.createElement('div');
      scriptPlaceholder.className = 'card__variants-script-placeholder';
      if (variantScript.parentNode) variantScript.parentNode.insertBefore(scriptPlaceholder, variantScript.nextSibling);
    }

    sheetBody.innerHTML = '';
    sheetBody.appendChild(variants);
    if (variantScript) sheetBody.appendChild(variantScript);

    activeState = {
      card: card,
      toggleBtn: toggleBtn
    };
    sheet.__activeCard = card;
    sheet.classList.add('is-open');
    backdrop.classList.add('is-open');
    toggleBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function() {
      if (sheetCloseBtn) sheetCloseBtn.focus();
    }, 50);
  }

  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open') || !activeState) return;
    var card = activeState.card;
    var toggleBtn = activeState.toggleBtn;
    var variants = sheetBody.querySelector('.card__variants');
    if (variants) {
      var placeholder = card.querySelector('.card__variants-placeholder');
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(variants, placeholder);
        placeholder.remove();
      } else {
        var content = card.querySelector('.card__content');
        if (content) content.appendChild(variants);
      }
    }

    var movedScript = sheetBody.querySelector('script[id^="Variants-"]');
    var scriptPlaceholder = card.querySelector('.card__variants-script-placeholder');
    if (movedScript && scriptPlaceholder && scriptPlaceholder.parentNode) {
      scriptPlaceholder.parentNode.insertBefore(movedScript, scriptPlaceholder);
      scriptPlaceholder.remove();
    }

    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    sheet.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    sheet.__activeCard = null;
    activeState = null;
  }

  function handleBodyClick(e) {
    var target = e.target;

    var sheetToggleBtn = target.closest('.card__variants-toggle');
    if (sheetToggleBtn) {
      var sheetCard = sheetToggleBtn.closest('.product-card-wrapper');
      if (sheetCard && !isDesktop.matches) {
        e.preventDefault();
        openSheet(sheetCard, sheetToggleBtn);
      }
      toggleInfoContainer(sheetCard);
      return;
    }

    var mobileToggleBtn = target.closest('.mobile-variants-toggle');
    if (mobileToggleBtn) {
      var mobileCard = mobileToggleBtn.closest('.product-card-wrapper');
      toggleInfoContainer(mobileCard);
      return;
    }

    var mobileCloseBtn = target.closest('.mobile-variants-close-button');
    if (mobileCloseBtn) {
      var closeCard = mobileCloseBtn.closest('.product-card-wrapper');
      closeInfoContainer(closeCard);
      return;
    }

    if (sheetCloseBtn && target === sheetCloseBtn) {
      closeSheet();
      return;
    }

    if (backdrop && target === backdrop) {
      closeSheet();
    }
  }

  function init() {
    if (window[TOGGLE_INIT_FLAG]) return;
    window[TOGGLE_INIT_FLAG] = true;

    ensureSheet();
    document.body.addEventListener('click', handleBodyClick);
    window.addEventListener('keydown', function(ev) {
      if (ev.key === 'Escape') closeSheet();
    });
    window.addEventListener('resize', function() {
      if (isDesktop.matches) closeSheet();
    });
  }

  onReady(init);
})();